__turbopack_context__.v({
  "className": "poppins_d9cde2ef-module__BUxgpG__className",
});
